import { ReactNode } from "react";
import { canEdit } from "../../utils/permissions";

const EditOnly = ({ children }: { children: ReactNode }) => {
    if (!canEdit()) return null;

    return <>{children}</>;
};

export default EditOnly;
